import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

/**
 * Monthly trend line used by the admin and company dashboards. Takes its
 * container's width (was a fixed 500px that overflowed on phones); `action`
 * (e.g. a year picker) sits in its own row above the chart so it can never
 * cover the plot on a narrow screen.
 */
const TrendChart = ({ data, dataKey, label, action }) => (
  <div className="flex flex-col gap-2">
    {action && <div className="flex justify-end">{action}</div>}
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
      <div className="min-w-0 flex-1">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <Line
              type="linear"
              dataKey={dataKey}
              stroke="#B4C540"
              strokeWidth={2}
            />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <span className="text-lg uppercase text-[#575A6C] sm:w-32 sm:text-2xl">
        {label}
      </span>
    </div>
  </div>
);

export default TrendChart;
